export default __webpack_public_path__ + "static/media/rest-api.33b5673c.gif";